module.exports = __webpack_public_path__ + "img/index-process.795576a.png";